module.exports = __webpack_public_path__ + "static/media/reset-page.8ba51f97.png";